module.exports = __webpack_public_path__ + "img/logofooter.abb30eb1.png";